import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import type {
    InitPromozavrPayload,
    PromozavrRendererSource,
    PromozavrState,
    SelectPromoModelInput,
    SelectPromoModelResponse,
} from './types';

const initialState: PromozavrState = {
    status: 'idle',
    isSelected: false,
    rendererSource: 'local',
};

export const initPromozavr = createAction<InitPromozavrPayload>('@PROMOZAVR/INIT');

const promozavrSlice = createSlice({
    name: '@PROMOZAVR',
    initialState,
    reducers: {
        resetPromozavrState() {
            return initialState;
        },
        startPromozavrRequest(
            state,
            {
                payload,
            }: PayloadAction<{
                request: SelectPromoModelInput;
                requestKey: string;
                rendererSource: PromozavrRendererSource;
            }>
        ) {
            state.status = 'loading';
            state.request = payload.request;
            state.requestKey = payload.requestKey;
            state.selectedPromo = undefined;
            state.translations = undefined;
            state.images = undefined;
            state.isSelected = false;
            state.rendererSource = payload.rendererSource;
            state.lastError = undefined;
        },
        finishPromozavrRequest(state, { payload }: PayloadAction<SelectPromoModelResponse>) {
            state.status = 'success';
            state.selectedPromo = payload.selectedPromos?.[0];
            state.translations = payload.translations;
            state.images = payload.images;
            state.isSelected = payload.isSelected;
            state.lastError = undefined;
        },
        failPromozavrRequest(state, { payload }: PayloadAction<string>) {
            state.status = 'error';
            state.selectedPromo = undefined;
            state.translations = undefined;
            state.images = undefined;
            state.isSelected = false;
            state.lastError = payload;
        },
        setPromozavrRendererSource(state, { payload }: PayloadAction<PromozavrRendererSource>) {
            state.rendererSource = payload;
        },
    },
});

export const {
    failPromozavrRequest,
    finishPromozavrRequest,
    resetPromozavrState,
    setPromozavrRendererSource,
    startPromozavrRequest,
} = promozavrSlice.actions;

export const promozavrReducer = promozavrSlice.reducer;
